<div class="card bg-transparent border-0 shadow mt-3 p-4">
    <canvas baseChart #myCanvas
        [datasets]="lineChartData" 
        [labels]="lineChartLabels" 
        [options]="lineChartOptions"
        [colors]="lineChartColors" 
        chartType="line" height="100">
    </canvas>
</div>

<div class="card bg-transparent border-0 shadow mt-3 p-3" style="min-height: 38vh;max-height: 38vh; overflow-y: scroll;">
    <app-notifications></app-notifications>
</div>

<!-- <hr> -->


